/**
 * CSRF protection utilities
 */

/**
 * Fetches a CSRF token from the backend
 * @returns {Promise<string>} CSRF token
 */
export const getCsrfToken = async () => {
  try {
    const response = await fetch('/api/csrf-token', {
      method: 'GET',
      credentials: 'include', // Include cookies for session-based CSRF
    });

    if (!response.ok) {
      throw new Error('Failed to fetch CSRF token');
    }

    const data = await response.json();
    return data.csrf_token;
  } catch (error) {
    console.error('CSRF token fetch error:', error);
    // Return empty string if CSRF is not available - forms should still work
    return '';
  }
};

/**
 * Adds CSRF token to request headers
 * @param {Object} headers - Existing headers object
 * @returns {Promise<Object>} Headers with CSRF token added
 */
export const addCsrfHeader = async (headers = {}) => {
  const csrfToken = await getCsrfToken();

  if (csrfToken) {
    return {
      ...headers,
      'X-CSRF-Token': csrfToken,
    };
  }

  return headers;
};

/**
 * Hook for managing CSRF tokens in React components
 * @returns {Object} CSRF utilities
 */
export const useCsrf = () => {
  return {
    getCsrfToken,
    addCsrfHeader,
  };
};



